import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M1 3v18h22V3H1zm20 16H3V5h18v14zM9 8h2v8H9zm4 0h2v8h-2z"
}), 'PausePresentationSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PausePresentationSharp.js
// module id = 5231
// module chunks = 2